import { FilterValue } from "../Filters/FilterValue";

export const PaymentMode: FilterValue[] = [
  { id: "0", value: "" },
  { id: "1", value: "Current Account" },
  // { id: "2", value: "Cash" },
  { id: "3", value: "Credit Card" },
  // { id: "4", value: "AMEX Card" },
  // { id: "5", value: "KODO Card" },
  // { id: "6", value: "KODO Virtual Account" },
  // { id: "7", value: "Not Applicable" },
];
